var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['live-completed', {
      'live-completed--deleted': _vm.type === 'deleted'
    }]
  }, [_vm._v(_vm._s(_vm.text))]);
};
var staticRenderFns = [];
export { render, staticRenderFns };